document.addEventListener('DOMContentLoaded', () => {
  initMembershipHero();
  initPricingToggle();
  initPresetCalendar();
});

/* ==============================
   MEMBERSHIP HERO IMAGE FLIP
============================== */
function initMembershipHero() {
  const cards = document.querySelectorAll('.membership-hero__card');
  if (!cards.length) return;

  cards.forEach((card, index) => {
    const frontImg = card.querySelector('.membership-hero__card-img--front');
    const backImg = card.querySelector('.membership-hero__card-img--back');
    if (!frontImg || !backImg) return;

    let showingFront = true;
    const delay = 2500 + index * 500 + Math.random() * 1000;

    setInterval(() => {
      frontImg.style.opacity = showingFront ? '0' : '1';
      backImg.style.opacity = showingFront ? '1' : '0';
      showingFront = !showingFront;
    }, delay);
  });
}

/* ==============================
   PRICING PLAN TOGGLE
============================== */
function initPricingToggle() {
  const cards = document.querySelectorAll('.pricing-card');
  const togglePills = document.querySelectorAll('.pricing-section__toggle-pill');
  if (!cards.length || !togglePills.length) return;

  function selectPlan(plan) {
    cards.forEach(card =>
      card.classList.toggle('is-selected', card.dataset.plan === plan)
    );
    togglePills.forEach(pill =>
      pill.classList.toggle('active', pill.dataset.togglePlan === plan)
    );
  }

  cards.forEach(card => {
    card.addEventListener('click', e => {
      if (e.target.closest('.pricing-card__cta')) return;
      selectPlan(card.dataset.plan);
    });
  });

  togglePills.forEach(pill => {
    pill.addEventListener('click', () => selectPlan(pill.dataset.togglePlan));
  });
}

/* ==============================
   PRESET CALENDAR
============================== */
function initPresetCalendar() {
  const container = document.querySelector('.preset-calendar');
  if (!container) return;

  // DATA must exist from 123presets-membership-data.js
  const PRESET_DATA = window.PRESET_DATA;
  if (!PRESET_DATA || !Array.isArray(PRESET_DATA.months)) return;

  let currentMonth = 0;
  let currentView = 'month';
  let currentPlan = 'yearly';
  let modalPreset = null;
  let modalImageIndex = 0;
  const NOW_MONTH = new Date().getMonth();

  const qs = (id) => document.getElementById(id);

  function renderNavPills() {
    const pillsContainer = qs('nav-pills');
    if (!pillsContainer) return;

    pillsContainer.innerHTML = PRESET_DATA.months.map((month, i) => {
      const activeClass = i === currentMonth ? ' active' : '';
      return `<button class="preset-calendar__nav-pill${activeClass}" data-month="${i}">
        ${month.name.substring(0, 3)}
      </button>`;
    }).join('');
  }

  function renderDropdownMenu() {
    const menu = qs('dropdown-menu');
    if (!menu) return;

    menu.innerHTML = PRESET_DATA.months.map((month, i) => {
      const activeClass = i === currentMonth ? ' active' : '';
      return `<div class="preset-calendar__dropdown-item${activeClass}" data-month="${i}">
        <span>${month.name}</span>
        <span class="preset-calendar__dropdown-count">${month.drops.length} packs</span>
      </div>`;
    }).join('');

    updateDropdownLabel();
  }

  function updateDropdownLabel() {
    const label = qs('dropdown-label');
    if (!label) return;
    const month = PRESET_DATA.months[currentMonth];
    label.textContent = `${month.name} - ${month.drops.length} packs`;
  }

  function renderGrid() {
    const grid = qs('preset-grid');
    if (!grid) return;

    const month = PRESET_DATA.months[currentMonth];
    const isMonthlyPlan = currentPlan === 'monthly';
    const isPastMonth = currentMonth < NOW_MONTH;
    const isLocked = isMonthlyPlan && isPastMonth;

    grid.innerHTML = month.drops.map(drop => {
      const lockedClass = isLocked ? ' locked' : '';
      const iconClass = isLocked ? 'la-lock' : 'la-eye';
      const previewBtn = !isLocked ? `<button class="preset-calendar__card-preview-btn">Preview</button>` : '';

      return `<div class="preset-calendar__card${lockedClass}" data-preset-id="${drop.id}">
        <div class="preset-calendar__card-image">
          <img src="${drop.thumbnail}" alt="${drop.name}" loading="lazy">
        </div>
        <div class="preset-calendar__card-overlay"><i class="la ${iconClass}"></i></div>
        ${previewBtn}
        <div class="preset-calendar__card-info">
          <h4 class="preset-calendar__card-name">${drop.name}</h4>
          <p class="preset-calendar__card-date">${drop.date} - 10 presets</p>
        </div>
      </div>`;
    }).join('');
  }

  function renderAllView() {
    const allView = qs('preset-all-view');
    if (!allView) return;

    const isMonthlyPlan = currentPlan === 'monthly';

    allView.innerHTML = PRESET_DATA.months.map((month, m) => {
      const isPastMonth = m < NOW_MONTH;
      const isCurrentMonth = m === NOW_MONTH;
      const isLocked = isMonthlyPlan && isPastMonth;
      const nowBadge = isCurrentMonth ? `<span class="preset-calendar__month-now">NOW</span>` : '';

      const cards = month.drops.map(drop => {
        const lockedClass = isLocked ? ' locked' : '';
        const iconClass = isLocked ? 'la-lock' : 'la-eye';
        const previewBtn = !isLocked ? `<button class="preset-calendar__card-preview-btn">Preview</button>` : '';

        return `<div class="preset-calendar__card${lockedClass}" data-preset-id="${drop.id}">
          <div class="preset-calendar__card-image">
            <img src="${drop.thumbnail}" alt="${drop.name}" loading="lazy">
          </div>
          <div class="preset-calendar__card-overlay"><i class="la ${iconClass}"></i></div>
          ${previewBtn}
          <div class="preset-calendar__card-info">
            <h4 class="preset-calendar__card-name">${drop.name}</h4>
            <p class="preset-calendar__card-date">${drop.date} - 10 presets</p>
          </div>
        </div>`;
      }).join('');

      return `<div class="preset-calendar__month-group">
        <div class="preset-calendar__month-header">
          <h3 class="preset-calendar__month-name">${month.name}</h3>
          ${nowBadge}
          <span class="preset-calendar__month-meta">${month.drops.length} packs - ${month.theme}</span>
        </div>
        <div class="preset-calendar__month-grid">${cards}</div>
      </div>`;
    }).join('');
  }

  function findPresetById(id) {
    for (const month of PRESET_DATA.months) {
      for (const drop of month.drops) {
        if (drop.id === parseInt(id, 10)) return drop;
      }
    }
    return null;
  }

  function renderModal() {
    if (!modalPreset) return;

    const modal = qs('preset-modal');
    if (!modal) return;

    const gallery = modal.querySelector('.preset-calendar__modal-gallery');
    const image = qs('modal-image');
    const name = qs('modal-name');
    const meta = qs('modal-meta');
    const release = qs('modal-release');

    if (!image || !name || !meta || !release) return;

    const images = Array.isArray(modalPreset.images) ? modalPreset.images.filter(x => x && x !== 'x') : [];
    const src = images[modalImageIndex] || modalPreset.thumbnail;

    name.textContent = modalPreset.name;
    meta.textContent = `${modalPreset.fullDate} - 10 presets`;
    release.textContent = `Releases ${modalPreset.date}`;

    if (gallery) {
      gallery.classList.remove('is-loaded');
      gallery.classList.add('is-loading');
    }

    image.onload = () => {
      if (gallery) {
        gallery.classList.remove('is-loading');
        gallery.classList.add('is-loaded');
      }
    };

    image.onerror = () => {
      if (gallery) {
        gallery.classList.remove('is-loading');
        gallery.classList.add('is-loaded');
      }
    };

    image.alt = modalPreset.name;
    image.src = src;

    const prevArrow = modal.querySelector('.preset-calendar__modal-nav--prev');
    const nextArrow = modal.querySelector('.preset-calendar__modal-nav--next');

    if (prevArrow && nextArrow) {
      if (images.length <= 1) {
        prevArrow.style.display = 'none';
        nextArrow.style.display = 'none';
      } else {
        prevArrow.style.display = 'flex';
        nextArrow.style.display = 'flex';
      }
    }

    modal.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    const modal = qs('preset-modal');
    if (modal) modal.classList.remove('open');
    document.body.style.overflow = '';
    modalPreset = null;
    modalImageIndex = 0;
  }

  // PLAN TOGGLE (monthly/yearly)
  document.querySelectorAll('[data-plan-btn]').forEach(btn => {
    btn.addEventListener('click', () => {
      const plan = btn.getAttribute('data-plan-btn');
      currentPlan = plan;
      container.setAttribute('data-plan', plan);

      document.querySelectorAll('[data-plan-btn]').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');

      renderGrid();
      renderAllView();
    });
  });

  // VIEW TOGGLE (month/all)
  document.querySelectorAll('[data-view-toggle]').forEach(btn => {
    btn.addEventListener('click', () => {
      const view = btn.getAttribute('data-view-toggle');
      currentView = view;
      container.setAttribute('data-view', view);

      document.querySelectorAll('[data-view-toggle]').forEach(b => b.classList.remove('active'));
      document.querySelectorAll(`[data-view-toggle="${view}"]`).forEach(b => b.classList.add('active'));
    });
  });

  // NEXT/PREV month
  document.querySelector('[data-nav="prev"]')?.addEventListener('click', () => {
    currentMonth = (currentMonth - 1 + 12) % 12;
    renderNavPills();
    renderDropdownMenu();
    renderGrid();
  });

  document.querySelector('[data-nav="next"]')?.addEventListener('click', () => {
    currentMonth = (currentMonth + 1) % 12;
    renderNavPills();
    renderDropdownMenu();
    renderGrid();
  });

  // NAV PILLS
  qs('nav-pills')?.addEventListener('click', (e) => {
    const pill = e.target.closest('[data-month]');
    if (!pill) return;

    currentMonth = parseInt(pill.getAttribute('data-month'), 10);
    currentView = 'month';
    container.setAttribute('data-view', 'month');

    document.querySelectorAll('[data-view-toggle]').forEach(b => b.classList.remove('active'));
    document.querySelectorAll('[data-view-toggle="month"]').forEach(b => b.classList.add('active'));

    renderNavPills();
    renderDropdownMenu();
    renderGrid();
  });

  // DROPDOWN OPEN/CLOSE
  const dropdown = qs('month-dropdown');
  const trigger = dropdown?.querySelector('.preset-calendar__dropdown-trigger');
  trigger?.addEventListener('click', (e) => {
    e.stopPropagation();
    dropdown.classList.toggle('open');
  });

  qs('dropdown-menu')?.addEventListener('click', (e) => {
    const item = e.target.closest('[data-month]');
    if (!item) return;

    currentMonth = parseInt(item.getAttribute('data-month'), 10);
    dropdown?.classList.remove('open');
    renderNavPills();
    renderDropdownMenu();
    renderGrid();
  });

  document.addEventListener('click', () => dropdown?.classList.remove('open'));

  // OPEN MODAL (event delegation)
  document.addEventListener('click', (e) => {
    const card = e.target.closest('.preset-calendar__card');
    if (!card || card.classList.contains('locked')) return;

    const presetId = card.getAttribute('data-preset-id');
    modalPreset = findPresetById(presetId);
    modalImageIndex = 0;
    renderModal();
  });

  // CLOSE MODAL buttons
  document.querySelectorAll('[data-modal-close]').forEach(btn => {
    btn.addEventListener('click', closeModal);
  });

  // MODAL NAV
  document.querySelector('[data-modal-nav="prev"]')?.addEventListener('click', (e) => {
    e.stopPropagation();
    if (!modalPreset) return;
    const images = Array.isArray(modalPreset.images) ? modalPreset.images.filter(x => x && x !== 'x') : [];
    if (images.length <= 1) return;
    modalImageIndex = (modalImageIndex - 1 + images.length) % images.length;
    renderModal();
  });

  document.querySelector('[data-modal-nav="next"]')?.addEventListener('click', (e) => {
    e.stopPropagation();
    if (!modalPreset) return;
    const images = Array.isArray(modalPreset.images) ? modalPreset.images.filter(x => x && x !== 'x') : [];
    if (images.length <= 1) return;
    modalImageIndex = (modalImageIndex + 1) % images.length;
    renderModal();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeModal();
  });

  // INITIAL RENDER
  renderNavPills();
  renderDropdownMenu();
  renderGrid();
  renderAllView();
}
